var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagRepublicOfMacedonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4333 31.8161C21.0355 31.4191 23.4309 30.3943 25.4618 28.9024L16 16L18.4333 31.8161Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5666 0.183838C10.9645 0.580838 8.56909 1.60559 6.53809 3.0974L16 15.9999L13.5666 0.183838Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53809 28.9024C8.56896 30.3942 10.9643 31.419 13.5665 31.8161L16 16L6.53809 28.9024Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.09716 6.53809C1.60528 8.56909 0.580656 10.9644 0.183594 13.5666L15.9997 16L3.09716 6.53809Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.183594 18.4333C0.580594 21.0355 1.60534 23.4309 3.09722 25.4618L15.9997 16L0.183594 18.4333Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8161 13.5666C31.419 10.9644 30.3943 8.56902 28.9024 6.53809L16 15.9999L31.8161 13.5666Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4618 3.09734C23.4308 1.60553 21.0355 0.580838 18.4333 0.183838L16 15.9999L25.4618 3.09734Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9026 25.4618C30.3944 23.4309 31.4191 21.0354 31.8162 18.4333L16 16L28.9026 25.4618Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9997 21.5652C19.0732 21.5652 21.5649 19.0736 21.5649 16C21.5649 12.9264 19.0732 10.4348 15.9997 10.4348C12.9261 10.4348 10.4345 12.9264 10.4345 16C10.4345 19.0736 12.9261 21.5652 15.9997 21.5652Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.174C18.3052 20.174 20.1739 18.3053 20.1739 16.0001C20.1739 13.6949 18.3052 11.8262 16 11.8262C13.6948 11.8262 11.826 13.6949 11.826 16.0001C11.826 18.3053 13.6948 20.174 16 20.174Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagRepublicOfMacedonia);
export default __webpack_public_path__ + "static/media/flag_republic_of_macedonia.0f13d0de8073ec6d4fcad16a7dcdf9e5.svg";
export { ForwardRef as ReactComponent };